import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import Wrapper from "../../components/Wrapper";
import DataGrid from "../../components/DataGrid";
import Breadcrumbs from "../../components/Breadcrumbs";
import format from "../../utils/ISOToReadable";
import { useDispatch, useSelector } from "react-redux";
import useRequest from "../../hooks/useRequest";
import DeleteIcon from "@mui/icons-material/Delete";
import Calling from "./58-call-phone-outline.gif";
import ContactPhoneIcon from "@mui/icons-material/ContactPhone";
import Tooltip from "@mui/material/Tooltip";
import {
  CHANNELS,
  CLIENTS,
  CLIENTS_COMMENTS,
  CLIENTS_HISTORY,
  CLIENTS_SELECTED_DELETE,
  CLIENTS_TRANSFER,
  CLIENTS_TRANSFER_PROJECT,
  EMPLOYEES,
  PROJECTS,
  STATUS,
} from "../../data/APIs";
import {
  Button,
  Stack,
  Box,
  FormControlLabel,
  InputAdornment,
  MenuItem,
  Checkbox,
  RadioGroup,
  Radio,
  FormGroup,
  Menu,
  TextField,
  IconButton,
  Typography,
} from "@mui/material";
import useAfterEffect from "../../hooks/useAfterEffect";
import InputField from "../../features/form/components/InputField";
import useControls from "../../hooks/useControls";
import Form, {
  MultiSelectItem,
  NumberField,
  PhoneField,
  SelectField,
  TextareaField,
} from "../../features/form";
import { v4 as uuid } from "uuid";
import filter from "../../utils/ClearNull";
import AutocompleteField from "../../features/form/components/AutocompleteField";
import Dialog, {
  DialogButton,
  DialogButtonsGroup,
  DialogContent,
  DialogForm,
  DialogHeading,
  DialogInfoWindow,
  DialogInputField,
  DialogMultiSelectField,
  DialogNumberField,
  DialogPhoneField,
  DialogSelectField,
  DialogTable,
} from "../../features/dialog";

import moment from "moment";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import CallIcon from "@mui/icons-material/Call";
import ChangeCircleIcon from "@mui/icons-material/ChangeCircle";
import ModeCommentIcon from "@mui/icons-material/ModeComment";
import DateRangeIcon from "@mui/icons-material/DateRange";

import * as XLSX from "xlsx";
import DialogPeopleWindow, {
  DialogSelectItem,
} from "../../features/dialog/components/DialogPeopleWindow";
import usePropState from "../../hooks/usePropState";
import compare from "../../utils/Compare";
import useIsPermitted from "../../features/permissions/hook/useIsPermitted";
import PermissionsGate from "../../features/permissions/components/PermissionsGate";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import useConfirmMessage from "../../hooks/useConfirmMessage";
import { json } from "react-router-dom";

const ViewClients = () => {
  // Change lang
  const lang = useSelector((state) => state.lang.value.lang);
  const viewClientsLang = useSelector((state) => state.lang.value.viewClients);
  const globalLang = useSelector((state) => state.lang.value.global);
  const userInfo = useSelector((state) => state.userInfo.value);
  //////////////////////////////////
  //----store----
  const clientsStore = useSelector((state) => state.clients.value);

  const clientCommentsStore = useSelector(
    (state) => state.clientComments.value
  );
  const employeesStore = useSelector((state) => state.employees.value);
  const projectsStore = useSelector((state) => state.projects.value);
  const channelsStore = useSelector((state) => state.channels.value);
  const statusStore = useSelector((state) => state.status.value);

  const dispatch = useDispatch();

  //----states----
  const [isCleared, setIsCleared] = useState(null);
  const [openTransferProject, setOpenTransferProject] = useState(false);
  const [
    openTransferMultipleClientsToEmployee,
    setOpenTransferMultipleClientsToEmployee,
  ] = useState(false);
  const [clientDetails, setClientDetails] = useState({
    details: null,
    tab: "details",
  });
  const [selected, setSelected] = useState([]);
  const [requestParams, setRequestParams] = useState({
    currentPage: [["page", 1]],
  });

  const [{ controls,invalid,required }, { setControl, resetControls }] = useControls([
    {
      control: "name",
      value: "",
      isRequired: false,
      // validations: [
      //   {
      //     test: /^[a-zA-Z\s]+$/,
      //     message:globalLang.textname[lang],
      //   },
      // ],
    },
    {
      control: "employee",
      value:"",
      isRequired: false,
    },
    {
      control: "code",
      value: "+20",
      isRequired: false,
    },
    {
      control: "phone",
      value: "",
      isRequired: false,
    },

    {
      control: "project",
      value: "",
      isRequired: false,
    },
    {
      control: "channel",
      value: "",
      isRequired: false,
    },
    {
      control: "status",
      value: "",
      isRequired: false,
    },
    {
      control: "max_price",
      value: "",
      isRequired: false,
      validations: [
        {
          customValidation: (controls) => controls.max_price>controls.min_price,
          message:globalLang.greatpricethanmin[lang],
        },
      ],
    },
    {
      control: "min_price",
      value: "",
      isRequired: false,
    },
    // {
    //   control: "budgetType",
    //   value: "max_budget",
    //   isRequired: false,
    // },
    {
      control: "dateStart",
      value: "",
      isRequired: false,
    },
    {
      control: "dateEnd",
      value: "",
      isRequired: false,
    },
    {
      control: "history",
      value: "",
      isRequired: false,
    },
    {
      control: "created_by",
      value: "",
      isRequired: false,
    },
    {
      control: "newClients",
      value: false,
      isRequired: false,
    },
    {
      control: "additional_phone_code",
      value: "+20",
      isRequired: false
    }
  ]);

  //----request hooks----
  const [clientsGetRequest, clientsGetResponse] = useRequest({
    path: CLIENTS,
    method: "get",

  });

  const [clientCommentsGetRequest, clientCommentsGetResponse] = useRequest({
    path: CLIENTS_COMMENTS,
    method: "get",
  });

  const [clientHistoryGetRequest, clientHistoryGetResponse] = useRequest({
    path: CLIENTS_HISTORY,
    method: "get",
  });

  const [employeesGetRequest, employeesGetResponse] = useRequest({
    path: EMPLOYEES,
    method: "get",
  });

  const [projectsGetRequest, projectsGetResponse] = useRequest({
    path: PROJECTS,
    method: "get",
  });

  const [channelsGetRequest, channelsGetResponse] = useRequest({
    path: CHANNELS,
    method: "get",
  });

  const [statusGetRequest, statusGetResponse] = useRequest({
    path: STATUS,
    method: "get",
  });

  const [clientCommentPostRequest] = useRequest({
    path: CLIENTS_COMMENTS,
    method: "post",
  });

  const [clientTransferPostRequest, clientTransferPostResponse] = useRequest({
    path: CLIENTS_TRANSFER,
    method: "post",
    successMessage: globalLang.successedit[lang],
  });

  const [clientTransferProjectPostRequest, clientTransferProjectPostResponse] =
    useRequest({
      path: CLIENTS_TRANSFER_PROJECT,
      method: "post",
      successMessage:globalLang.changeproject[lang],
    });

  //----effects----
  useEffect(() => {
    getClients()
  }, []);

  useAfterEffect(() => {
    // if (!clientDetails.details) return;
    setClientDetails((old) => ({
      ...old,
      details: clientsStore.results.find((item) => item.id === old.details?.id),
    }));
   
  }, [clientsStore]);

  useAfterEffect(() => {
    const urlParams = new URLSearchParams();
  
  
    // Object.values(requestParams).map((item) =>
    //   item.map(([key, value]) => urlParams.append(key, value))
    // );
    // Object.keys(requestParams).map((ele,index)=>{urlParams.append(ele,Object.values(requestParams)[index])})
    // delete requestParams.currentPage
    
    Object.keys(requestParams).map((item) => requestParams[item]?.map(([key, value]) => urlParams.append(key, value)))
    delete requestParams.currentPage
    clientsGetRequest({
      params: urlParams,
      onSuccess: (res) => {
        dispatch({ type: "clients/set", payload: res.data });
      },
    });

  }, [requestParams]);

  //----functions----
  const getClients = () => {
    clientsGetRequest({
      onSuccess: (res) => {
        dispatch({ type: "clients/set", payload: res.data })
        
      },
    });
  };

  //===Start===== Delete Client Logic =========

  const [clientDeleteRequest, clientDeleteResponse] = useRequest({
    path: CLIENTS,
    method: "delete",
    successMessage: "تم الحذف بنجاح",
  });

  const deleteClient = (e, { id }) => {
    clientDeleteRequest({
      id: id,
      onSuccess: () => {
        dispatch({ type: "clients/deleteItem", payload: { id } });
      },
    });
  };

  const [handleDeleteClient, deleteClientConfirmDialog] = useConfirmMessage({
    onConfirm: deleteClient,
    text: globalLang.makesureofdelete[lang],
  });

  //===End===== Delete Client Logic =========

 
 






  const handlePaginate = (params) => {
  
    setRequestParams((old) => ({
      ...old,
      currentPage: [["page", params.current]],
    }));
  };

  const handleChecks = ({ checks }) => {
    setSelected(checks);
  };

  const handleChangeAmount = ({ value }) => {
    setRequestParams((old) => ({
      ...old,
      currentPage: [["page", 1]],
      amount: [["size", value]],
    }));
  };

  const handleFilter = (filters) => {
    
    setRequestParams((old) => ({
      ...old,
      filters: filters.map(({ query }) => query),
    }));
    // setRequestParams((old) => ({
    //   ...old,
    //   filters: Object.entries(requestBody).filter(([key,value])=>value)
    // }));
  };
  console.log(controls.employee);
  const handleFormFilterSubmit = () => {
    console.log(controls)
    const params = filter({
      obj: {
        name: controls.name?controls.name:"",
        agent: Array.isArray(controls.employee) ? controls.employee.map((ele)=>ele.value) : "",
        email: controls.email?controls.email:"",
        job: controls.job?controls.job:"",
        phone: controls?.phone?controls?.code+controls?.phone:"",
        bussiness: Array.isArray(controls.project)?controls.project.map((ele)=>ele.value):"",
        event: controls?.newClients ? "" : Array.isArray(controls.status)?controls.status.map((ele)=>ele.value):controls.status,
        channel: controls?.channel?controls.channel.value:"",
        state: controls?.newClients ? 1 : "",
        // [controls?.budgetType]: controls?.budget?.replace(/,/gi, ""),
        created_at_after:
          controls?.dateStart
            ? `${controls?.dateStart}`
            : "",
        created_at_before: controls?.dateEnd
          ? `${controls?.dateEnd}`
          : "",
        followup: controls?.history,
        created_by: controls?.created_by.value === 0 ? "0" : controls?.created_by.value,
        min_price:controls?.min_price,
        max_price:controls?.max_price,
        // created_at:[controls.dateStart,controls.dateEnd]
      },
      output: "object"
    });
    console.log(params)
    setRequestParams((old) => ({
      ...old,
      filters: Object.entries(params).filter(([key,value])=>value)}));
  };
  
  const handleClearFilters = () => {
    resetControls();
    setRequestParams((old) => ({ ...old, filters: [] }));
  
    setIsCleared(uuid());
  };

  const getEmployees = () => {
    if (employeesStore.results.length) return;
    employeesGetRequest({
      params: {
        size: 1000,
      },
      onSuccess: (res) => {
        dispatch({ type: "employees/set", payload: res.data });
      },
    });
  };

  const getProjects = () => {
    if (projectsStore.results.length) return;
    projectsGetRequest({
      params: {
        size: 1000,
      },
      onSuccess: (res) => {
        dispatch({ type: "projects/set", payload: res.data });
      },
    });
  };

  const getChannels = () => {
    if (channelsStore.results.length) return;
    channelsGetRequest({
      params: {
        size: 1000,
      },
      onSuccess: (res) => {
        dispatch({ type: "channels/set", payload: res.data });
      },
    });
  };

  const getStatus = () => {
    if (statusStore.results.length) return;
    statusGetRequest({
      params: {
        size: 1000,
      },
      onSuccess: (res) => {
        dispatch({ type: "status/set", payload: res.data });
      },
    });
  };

  const handleExportExcelSheet = () => {
    const properFormat = selected.map((item) => {
      console.log(item);
      return {
        full_name: item.name,
        phone: `${item?.country_code}${item?.phone}`,
        project: `${item.bussiness
          .map((project) => project?.name)
          .join(" ، ")}`,
        channel: `${item.channel.name}`,
        agent: `${item.agent.name}`,
        status: `${item.event}`,
        comment: `${item.comment}`,
        created_by: `${item.created_by}`,
        created_at: `${item.created_at}`,
      };
    });

    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.json_to_sheet(properFormat);

    XLSX.utils.book_append_sheet(wb, ws, "clientsSheet");

    XLSX.writeFile(wb, "CRM Clients Sheet.xlsx");
  };

  const getClientHistory = () => {
    clientHistoryGetRequest({
      params: {
        id: clientDetails.details.id,
      },
      onSuccess: (res) => {
        dispatch({ type: "clientHistory/set", payload: res.data });
      },
    });
  };

  const getComments = () => {
    clientCommentsGetRequest({
      params: {
        id: clientDetails.details.id,
      },
      onSuccess: (res) => {

        dispatch({ type: "clientComments/set", payload: res.data });
      },
    });
  };

  const handleCloseDetailsDialog = () => {
    setClientDetails((old) => ({ ...old, details: null, tab: "details" }));
  };

  const handleSubmitComment = async (e) => {
    const requestBody = filter({
      obj: e,
      output: "object",
    });

    return clientCommentPostRequest({
      body: requestBody,
      onSuccess: (res) => {
        dispatch({ type: "clientComments/addItem", payload: res.data });
        dispatch({
          type: "clients/patchItem",
          payload: {
            id: res.data.client_id,
            item: { comment: res.data.comment, event: res.data.event },
          },
        });
      },
    });
  };

  const handleSubmitEmployeeTransfer = (e) => {
    clientTransferPostRequest({
      body: e,
      onSuccess: (res) => {
        setOpenTransferMultipleClientsToEmployee(false);
        setClientDetails((old) => ({ ...old, details: null, tab: "details" }));
        if (res.data.hasOwnProperty("clients")) {
          res.data.clients.map((client) => {
            dispatch({
              type: "clients/patchItem",
              payload: { id: client.id, item: { ...client } },
            });
          });
        } else {
          dispatch({
            type: "clients/patchItem",
            payload: { id: res.data.id, item: { ...res.data } },
          });
        }
      },
    });
  };

  const handleSubmitProjectTransfer = (e) => {
    clientTransferProjectPostRequest({
      body: e,
      onSuccess: (res) => {
        setOpenTransferProject(false);
        if (res.data.hasOwnProperty("clients")) {
          res.data.clients.map((client) => {
            dispatch({
              type: "clients/patchItem",
              payload: { id: client.id, item: { ...client } },
            });
          });
        } else {
          dispatch({
            type: "clients/patchItem",
            payload: { id: res.data.id, item: { ...res.data } },
          });
        }
      },
    });
  };

  const [editData, setEditData] = useState(null);

  const isPermitted = useIsPermitted();

  //===Start===== Delete Selected Clients Logic ===========

  const [selectedClientsDeleteRequest, selectedClientsDeleteResponse] =
    useRequest({
      path: CLIENTS_SELECTED_DELETE,
      method: "delete",
      successMessage: "تم حذف العملاء بنجاح",
    });

  const deleteSelected = () => {
    selectedClientsDeleteRequest({
      body: {
        client: selected.map((client) => client.id),
      },
      onSuccess: () => {
        selected.map((client) => {
          dispatch({ type: "clients/deleteItem", payload: { id: client.id } });
        });
      },
    });
  };

  const [handleDeleteSelected, deleteSelectedConfirmDialog] = useConfirmMessage(
    {
      onConfirm: deleteSelected,
      text: globalLang.makesureofdelete[lang],
    }
  );

  //===End===== Delete Selected Clients Logic ===========

  const columns = [
    {
      field: "name",
      headerName: globalLang.name[lang],
      customContent: (user) => `${user?.name}`,
    },
    {
      field: "phone",
      headerName: globalLang.phone[lang],
      customContent: (user) => `${user.country_code}${user?.phone}`,
    },
    {
      field: "channel",
      headerName: globalLang.adChannel[lang],
      customContent: ({ channel }) => typeof channel === "string" ? `${channel}` : `${channel.name}`,
      customEmpty: globalLang.notFound[lang],
    },
    {
      field: "project",
      headerName: globalLang.project[lang],
      customContent: (({ bussiness }) => bussiness.length > 0 ? `${bussiness?.map((project) => project?.name).join(" ،  ")}` : "-"),
    },
    {
      field: "comment",
      headerName: globalLang.comment[lang],
      customContent: ({ comment }) =>
        comment?.length >= 18
          ? /\s/.test(comment)
            ? `${comment.split(" ").slice(0, 3).join(" ")}...`
            : `${comment.slice(0, 13)}...`
          : comment?.length === 0 ? "-" : comment,
      customEmpty: globalLang.notFound[lang],
    },
    {
      field: "event",
      headerName: globalLang.status[lang],
      customContent: ({ event }) => event.length === 0 ? "-" : `${event}`,
      customEmpty: globalLang.notFound[lang],

    },
    {
      field: "created_at",
      headerName: globalLang.createdAt[lang],
      customContent: ({ created_at }) => format(created_at),
    },
    {
      field: "created_by",
      headerName: globalLang.createdBy[lang],
    },
    {
      field: "followup",
      headerName: globalLang.previewDate[lang],
      customContent: ({ followup }) => (followup ? format(followup) : null),
      customEmpty: globalLang.notFound[lang],
    },
    {
      field: "agent",
      headerName: globalLang.employee[lang],
      customContent: ({ agent }) => Boolean(agent.name) && `${agent.name}`,
      customEmpty: globalLang.admin[lang],
    }, {
      field: "max_price",
      headerName: globalLang.max_price[lang],
      customContent: (params) => params.max_price,
      customEmpty: "0",
    }, {
      field: "min_price",
      headerName: globalLang.min_price[lang],
      customContent: (params) => params.min_price,
      customEmpty: "0",
    },{
      field: "transferred_by",
      headerName: globalLang.transferred_by[lang],
      customContent: (user) => user.transferred_by,
      customEmpty: globalLang.notFound[lang],
    }
  ];
  // /^(?:\+[0-9\d]*)$/
  useEffect(() => {

  }, [controls])
  return (
    <Wrapper>
      <Breadcrumbs
        path={[globalLang.customers[lang], viewClientsLang.allClients[lang]]}
      />

      {/* filteration form */}
      <Form
        childrenProps={{
          saveBtn: {
            onClick: handleFormFilterSubmit,
            children: globalLang.filter[lang],
          },
          closeBtn: {
            onClick: handleClearFilters,
          },
        }}
      >
        <InputField
          label={globalLang.name[lang]}
          placeholder={globalLang.name[lang]}
          value={controls.name}
          onChange={(e) => { let text=/^(?:[A-Za-z\u0600-\u06ff\s]*)$/
          let match=text.test(e.target.value)
          if(match){
            setControl("name", e.target.value)
          }else if(e.target.value===""){
            setControl("name","")
          }}}
        />
        <AutocompleteField
          label={globalLang.salesOfficer[lang]}
          placeholder={globalLang.salesOfficer[lang]}
          key={`employee ${isCleared}`}
          onOpen={getEmployees}
          id="combo-box-demo"
          isPending={employeesGetResponse.isPending}
           value={controls.employee}
          isOptionEqualToValue={(option, value) => option.value === value.value}
          getOptionLabel={(option) => option.label || []}
          onChange={(e, options, reason) => {
           console.log(reason,options)
            switch (reason) {
              case "selectOption":
                setControl("employee", options.map((ele)=>ele));
                break;
                case "removeOption":
                setControl("employee", options.map((ele)=>ele));
                break;
              case "clear":
                setControl("employee", "");
            }
          }}
          data={[
            {
              label:userInfo?.first_name+" "+userInfo?.last_name,
              value: userInfo?.id,
            },
            ...employeesStore.results.map((employee) => ({
              label: `${employee.user?.first_name} ${employee.user?.last_name}`,
              value: employee.id,
            })),
          ]}
          multiple
        />
        {/* <PhoneField
          label={globalLang.phone[lang]}
          placeholder={globalLang.phone[lang]}
          requiredCode
          selectProps={{
            value: controls.code,
            onChange: (e) => {
              setControl("code", e.target.value);
            },
          }}
          onChange={(e) => {
            setControl("phone", e.target.value);
          }}
          value={controls.phone}
        /> */}
        <AutocompleteField
          label={globalLang.project[lang]}
          placeholder={globalLang.project[lang]}
          key={`project ${isCleared}`}
          onOpen={getProjects}
          isPending={projectsGetResponse.isPending}
          value={controls.project}
          isOptionEqualToValue={(option, value) => option.value === value.value}
          onChange={(e, options, reason) => {
            switch (reason) {
              case "selectOption":
                setControl("project", options.map(ele => ele));
                break;
              case "removeOption":
                setControl("project", options.map(ele => ele));
                break;
              case "clear":
                setControl("project", "");
            }
          }}
          data={projectsStore.results.map((project) => ({
            label: project.name,
            value: project.id,
          }))}

          multiple
          autoSelect
        />
        
        <AutocompleteField
          label={globalLang.adChannel[lang]}
          placeholder={globalLang.adChannel[lang]}
          key={`channel ${isCleared}`}
          onOpen={getChannels}
          isPending={channelsGetResponse.isPending}
          value={controls.channel}
          isOptionEqualToValue={(option, value) => option.value === value.value}
          onChange={(e, options, reason) => {
            console.log(options)
            switch (reason) {
              case "selectOption":
                setControl("channel", options);
                break;
              case "clear":
                setControl("channel", "");
            }
          }}
          data={channelsStore.results.map((channel) => ({
            label: channel.name,
            value: channel.id,
          }))}
        />
        <AutocompleteField
          label={globalLang.status[lang]}
          placeholder={globalLang.status[lang]}
          key={`status ${isCleared}`}
          onOpen={getStatus}
          isPending={statusGetResponse.isPending}
          disabled={Boolean(controls.newClients)}
          value={controls.status}
          isOptionEqualToValue={(option, value) => option.value === value.value}
          onChange={(e, options, reason) => {
            console.log(options)
            switch (reason) {
              case "selectOption":
                setControl("status", options.map(ele => ele));
                break;
              case "removeOption":
                setControl("status", options.map(ele => ele));
                break;
              case "clear":
                setControl("status", "");
            }
          }}
          data={statusStore.results.map((status) => ({
            label: status.name,
            value: status.name,
          }))}
          multiple
        />
        <NumberField
          label={globalLang.min_price[lang]}
          placeholder={globalLang.min_price[lang]}
          thousandSeparator
          value={controls.min_price}
          onChange={(e) => {
            setControl("min_price", e.target.value);
          }}
          // required={required.includes("min_price")}
          error={Boolean(invalid.min_price)}
          helperText={invalid.min_price}
        />
        <NumberField
          label={globalLang.max_price[lang]}
          placeholder={globalLang.max_price[lang]}
          thousandSeparator
          value={controls.max_price}
          onChange={(e) => {
            setControl("max_price", e.target.value);
          }}
          required={required.includes("max_price")}
          error={Boolean(invalid.max_price)}
          helperText={invalid.max_price}
        />
        <PhoneField
          label={globalLang.phone[lang]}
          placeholder={globalLang.phone[lang]}
          required={required.includes("phone")}
          requiredCode
          selectProps={{
            value: controls.code,
            onChange: (e) => {setControl("code", e.target.value);console.log(controls.value)},
          }}
          onChange={(e) => setControl("phone", e.target.value)}
          value={controls.phone}

          error={Boolean(invalid.phone)}
          helperText={invalid.phone}
         
        />
        <InputField
          type="date"
          label={globalLang.periodFrom[lang]}
          value={controls.dateStart}
          onChange={(e) => {
            if (
              controls.dateEnd &&
              parseInt(controls.dateEnd.split("-").join("")) <
              parseInt(e.target.value.split("-").join(""))
            ) {
              setControl("dateStart", controls.dateEnd);
              return;
            }

            setControl("dateStart", e.target.value);
          }}
        />
        <InputField
          type="date"
          label={globalLang.periodTo[lang]}
          value={controls.dateEnd}
          onChange={(e) => {
            if (
              controls.dateStart &&
              parseInt(controls.dateStart.split("-").join("")) >
              parseInt(e.target.value.split("-").join(""))
            ) {
              setControl("dateEnd", controls.dateStart);
              return;
            }

            setControl("dateEnd", e.target.value);
          }}
        />
        <InputField
          type="date"
          label={globalLang.previewDate[lang]}
          value={controls.history}
          onChange={(e) => setControl("history", e.target.value)}
        />
        <AutocompleteField
          label={globalLang.created_by[lang]}
          placeholder={globalLang.created_by[lang]}
          key={`created_by ${isCleared}`}
          onOpen={getEmployees}
          isPending={employeesGetResponse.isPending}
          value={controls.created_by}
          isOptionEqualToValue={(option, value) => option.value === value.value}
          onChange={(e, options, reason) => {
            console.log(reason,options)
            switch (reason) {
              case "selectOption":
                setControl("created_by", options);
                break;
              case "clear":
                setControl("created_by", "");
            }
          }}
          data={[
            {
              label:userInfo?.first_name+" "+userInfo?.last_name,
              value: userInfo?.id,
            },
            ...employeesStore.results.map((employee) => ({
              label: `${employee.user?.first_name} ${employee.user?.last_name}`,
              value: employee.user.id,
            })),
          ]}
        />

        <Box sx={{ gridColumn: "1 / -1" }}>
          <FormControlLabel
            label={globalLang.newCustomers[lang]}
            control={
              <Checkbox
                checked={Boolean(controls.newClients)}
                onChange={(e) => setControl("newClients", e.target.checked)}
              />
            }
          />
        </Box>
      </Form>

      {/* datagrid */}

      <DataGrid
        columns={columns}
        rows={clientsStore.results}
        isPending={clientsGetResponse.isPending}
        total={clientsStore.count ? clientsStore.count : 1}
        onCheck={handleChecks}
        onEdit={isPermitted(
          (e, row) => setEditData(row),
          ["change_aqarclient"]
        )}
        onDelete={isPermitted(
          (e, row) => handleDeleteClient(e, row),
          ["delete_aqarclient"]
        )}
        onView={isPermitted(
          (e, row) => {
          setClientDetails((old) => ({
            ...old,
            details: row,
          }))
        },['view_historicalaqarclient'])}
        onPaginate={handlePaginate}
        onAmountChange={handleChangeAmount}
        onFilter={handleFilter}
      />

      <TransferToEmployeeDialog
        open={Boolean(
          clientDetails.details && clientDetails.tab === "transfer"
        )}
        onOpen={getEmployees}
        onClose={handleCloseDetailsDialog}
        onGoBack={() => setClientDetails((old) => ({ ...old, tab: "details" }))}
        initSelected={clientDetails?.details?.agent?.id}
        id={clientDetails.details?.id}
        data={[
          {
            title: "الأدمن",
            body: "الأدمن",
            picture: "asdfsd",
            id: null,
          },
          ...employeesStore.results.map((employee) => ({
            title: `${employee.user?.first_name} ${employee.user?.last_name}`,
            body: employee.job.title,
            id: employee.id,
            picture: employee.user.image,
          })),
        ]}
        isPending={employeesGetResponse.isPending}
        submitPending={clientTransferPostResponse.isPending}
        onSubmit={handleSubmitEmployeeTransfer}
      />

      <CommentDialog
        open={Boolean(clientDetails.details && clientDetails.tab === "comment")}
        onOpen={getComments}
        onClose={handleCloseDetailsDialog}
        onGoBack={() => setClientDetails((old) => ({ ...old, tab: "details" }))}
        isPending={clientCommentsGetResponse.isPending}
        data={clientCommentsStore?.results?.map((item) => ({
          id: item.id,
          client_id: item.client_id,
          body: item.comment,
          date: format(item.created_at),
          title: item.commenter.fullname,
          picture: item.commenter.image,
          status: item.event,
        }))}
        id={clientDetails.details?.id}
        onStatusOpen={getStatus}
        isStatusPending={statusGetResponse.isPending}
        status={statusStore.results.map((item) => ({
          name: item.name,
          value: item.id,
        }))}
        onSubmit={handleSubmitComment}
      />

      <InfoDialog
        open={Boolean(clientDetails.details && clientDetails.tab === "details")}
        onOpen={getClientHistory}
        onClose={handleCloseDetailsDialog}
        data={Boolean(clientDetails.details) && clientDetails.details}
        isHistoryPending={clientHistoryGetResponse.isPending}
        onTransferAgentClick={() =>
          setClientDetails((old) => ({ ...old, tab: "transfer" }))
        }
        onCommentsClick={() =>
          setClientDetails((old) => ({ ...old, tab: "comment" }))
        }
      />

      <TransferToEmployeeDialog
        open={openTransferMultipleClientsToEmployee}
        onClose={() => setOpenTransferMultipleClientsToEmployee(false)}
        onOpen={getEmployees}
        id={selected.map((item) => item.id)}
        data={[
          {
            title: "الأدمن",
            body: "الأدمن",
            picture: "asdfsd",
            id: null,
          },
          ...employeesStore.results.map((employee) => ({
            title: `${employee.user?.first_name} ${employee.user?.last_name}`,
            body: employee.job.title,
            id: employee.id,
            picture: employee.user.image,
          })),
        ]}
        isPending={employeesGetResponse.isPending}
        submitPending={clientTransferPostResponse.isPending}
        onSubmit={handleSubmitEmployeeTransfer}
      />

      <TransferToProjectDialog
        open={openTransferProject}
        onClose={() => setOpenTransferProject(false)}
        onOpen={getProjects}
        isPending={projectsGetResponse.isPending}
        id={selected.map((item) => item.id)}
        data={projectsStore.results.map((item) => ({
          name: item.name,
          picture: item.logo,
          id: item.id,
        }))}
        submitPending={clientTransferProjectPostResponse.isPending}
        onSubmit={handleSubmitProjectTransfer}
      />

      <EditDialog
        open={Boolean(editData)}
        onClose={() => setEditData(null)}
        data={editData}
      />

      {/* buttons */}
      <Stack
        direction="row"
        justifyContent="center"
        alignItems="center"
        spacing={2}
      >
        <PermissionsGate permissions={["delete_aqarclient"]}>
          <Button
            variant="contained"
            color="error"
            disabled={
              !Boolean(selected.length) ||
              selectedClientsDeleteResponse.isPending
            }
            sx={{ width: "200px", height: "50px" }}
            onClick={handleDeleteSelected}
          >
            {globalLang.deleteSelected[lang]}
          </Button>
        </PermissionsGate>
        <Button
          variant="contained"
          disabled={!Boolean(selected.length)}
          sx={{ width: "200px", height: "50px" }}
          onClick={() => handleExportExcelSheet()}
        >
          {globalLang.exportSelected[lang]}
        </Button>
        <PermissionsGate permissions={["aqartransfer_clients"]}>
          <Button
            variant="contained"
            disabled={!Boolean(selected.length)}
            sx={{ width: "200px", height: "50px" }}
            onClick={() => setOpenTransferMultipleClientsToEmployee(true)}
          >
            {globalLang.transferSelected[lang]}
          </Button>
        </PermissionsGate>
        <Button
          variant="contained"
          disabled={!Boolean(selected.length)}
          sx={{ width: "200px", height: "50px" }}
          onClick={() => setOpenTransferProject(true)}
        >
          {globalLang.changeSelected[lang]}
        </Button>
      </Stack>

      {selectedClientsDeleteResponse.successAlert}
      {selectedClientsDeleteResponse.failAlert}
      {clientDeleteResponse.successAlert}
      {clientDeleteResponse.failAlert}
      {clientTransferPostResponse.successAlert}
      {clientTransferProjectPostResponse.successAlert}
      {clientTransferProjectPostResponse.failAlert}
      {clientTransferPostResponse.failAlert}
      {deleteSelectedConfirmDialog}
      {deleteClientConfirmDialog}
      {clientsGetResponse.failAlert}
    </Wrapper>
  );
};

export default ViewClients;

export const InfoDialog = ({
  data,
  isHistoryPending,
  open,
  onOpen,
  onClose,
  onTransferAgentClick = () => { },
  onCommentsClick = () => { },
}) => {
  // Change lang
  const lang = useSelector((state) => state.lang.value.lang);
  const viewClientsLang = useSelector((state) => state.lang.value.viewClients);
  const globalLang = useSelector((state) => state.lang.value.global);

  //////////////////////////////////
  //----store----
  const historyStore = useSelector((state) => state.clientHistory.value);

  const dispatch = useDispatch();

  //====Start===== Preview Date Logic ===============

  const [previewDatePicker, setPreviewDatePicker] = useState(null);
  const openPreviewPicker = Boolean(previewDatePicker);
  const [selectedPreviewDate, setSelectedPreviewDate] = useState("");

  const [previewDatePatchRequest, previewDatePatchResponse] = useRequest({
    path: CLIENTS,
    method: "patch",
  });

  const handlePreviewSubmit = () => {
    previewDatePatchRequest({
      id: data.id,
      body: {
        user: {},
        followup: moment(selectedPreviewDate).format(),
      },
      onSuccess: (res) => {
        setPreviewDatePicker(null);
        dispatch({
          type: "clients/putItem",
          payload: { id: res.data.id, item: res.data },
        });
        data.followup = res.data.followup;
      },
    }).then(() => {
      setPreviewDatePicker(null);
    });
  };

  //----variables----  console.log(data)
  const info = [
    {
      name: globalLang.name[lang],
      value: `${data?.name}`,
    },
    {
      name: globalLang.phone[lang],
      value: `${data.country_code}${data?.phone}`,
      addition: (
        <Box sx={{ display: "flex", flexDirection: "row", flexWrap: "wrap" }}>
          <IconButton
            sx={{ color: "white" }}
            onClick={() =>
              window.open(
                "https://wa.me/" +
                `${data?.phone}`,
                "_blank"
              )
            }
          >
            <WhatsAppIcon fontSize="small" sx={{ color: "#5ef979" }} />
          </IconButton>
          <Tooltip title="truecaller" placement="top">
            <IconButton
              sx={{ color: "white" }}
              onClick={() =>
                window.open(
                  "https://www.truecaller.com/search/eg/" +
                  `${data?.phone}`,
                  "_blank"
                )
              }
            >
              <ContactPhoneIcon fontSize="small" sx={{ color: "#fff" }} />
            </IconButton>
          </Tooltip>
          <Tooltip title="...calling" placement="top">
            <IconButton
              sx={{ color: "white" }}
              onClick={() =>
                window.open(
                  `tel: ${data?.phone}`,
                  "",
                  "width=400,height=400,left=500 ,top=200"
                )
              }
            >
              <img src={Calling} style={{ width: "20px", height: "20px" }} />
            </IconButton>
          </Tooltip>
        </Box>
      ),
    },
    {
      name: globalLang.project[lang],
      value: Array.isArray(data?.bussiness) ? data?.bussiness.map((project) => project?.name)?.join(",") : "-",
      customEmpty: globalLang.notFound[lang],
    },
    {
      name: globalLang.adChannel[lang],
      value: data?.channel?.name,
    },
    {
      name: globalLang.employee[lang],
      value: data?.agent?.name,
      addition: (
        <PermissionsGate permissions={["aqartransfer_clients"]}>
          <IconButton sx={{ color: "white" }} onClick={onTransferAgentClick}>
            <ChangeCircleIcon
              sx={{ color: "white", transform: "scale(1.2)" }}
            />
          </IconButton>
        </PermissionsGate>
      ),
    },
    {
      name: globalLang.createdAt[lang],
      value: data?.created_at ? format(data?.created_at) : "",
      customEmpty: globalLang.notFound[lang],
    },
    {
      name: globalLang.previewDate[lang],
      value: data?.followup ? format(data?.followup) : "",
      customEmpty: globalLang.notFound[lang],
      addition: (
        <PermissionsGate permissions={[]}>
          <IconButton
            sx={{ color: "white" }}
            onClick={(e) => setPreviewDatePicker(e.currentTarget)}
          >
            <DateRangeIcon sx={{ color: "white", transform: "scale(1.2)" }} />
          </IconButton>
          <Menu
            open={openPreviewPicker}
            anchorEl={previewDatePicker}
            onClose={() => setPreviewDatePicker(null)}
            PaperProps={{
              sx: {
                "& .MuiList-root": {
                  p: 2,
                },
              },
            }}
          >
            <LocalizationProvider dateAdapter={AdapterMoment}>
              <DateTimePicker
                label="DateTimePicker"
                value={selectedPreviewDate}
                onChange={(newValue) => {
                  setSelectedPreviewDate(newValue);
                }}
                renderInput={(params) => (
                  <InputField
                    sx={{
                      width: "100%",
                      "& .MuiInputBase-root": {
                        border: "none",
                      },
                    }}
                    {...params}
                  />
                )}
              />
            </LocalizationProvider>
            <Button
              variant="contained"
              sx={{ width: "100%", marginTop: 3 }}
              disabled={previewDatePatchResponse.isPending}
              onClick={(e) => {
                handlePreviewSubmit({
                  ...e,
                  selectedPreviewDate,
                  clientId: data.id,
                });
              }}
            >
              {globalLang.save[lang]}
            </Button>
          </Menu>
        </PermissionsGate>
      ),
    },
    {
      name: globalLang.comment[lang],
      value:
        data?.comment?.length >= 18
          ? /\s/.test(data?.comment)
            ? `${data?.comment?.split(" ").slice(0, 3).join(" ")}...`
            : `${data?.comment?.slice(0, 13)}...`
          : data?.comment ? data?.comment : "-",
      addition: (
        <PermissionsGate permissions={["view_aqarclientcomment"]}>
          <IconButton sx={{ color: "white" }} onClick={onCommentsClick}>
            <ModeCommentIcon sx={{ color: "white" }} />
          </IconButton>
        </PermissionsGate>
      ),
    },
    // {
    //   name: globalLang.budget[lang],
    //   value: data?.max_budget,
    // },
  ];

  const columns = [
    {
      field: "name",
      headerName: globalLang.name[lang],
      customContent: ({ rowData }) => `${rowData?.name}`,
      customEmpty: globalLang.notFound[lang],
    }, ,
    {
      field: "projects",
      headerName: globalLang.projects[lang],
      customContent: ({ rowData }) => rowData?.bussiness?.map((project) => project)?.join(","),
      customEmpty: globalLang.notFound[lang],
    },
    {
      field: "channel",
      headerName: globalLang.channels[lang],
    },
    {
      field: "agent",
      headerName: globalLang.employee[lang],
      customContent: ({ rowData }) => rowData?.agent,
      customEmpty: globalLang.notFound[lang],
    },
    {
      field: "history_user",
      headerName: globalLang.editor[lang],
      customContent: ({ rowData }) => rowData.history_user.first_name && rowData.history_user.last_name ? `${rowData.history_user.first_name} ${rowData.history_user.last_name}` : "-",

      customEmpty: globalLang.notFound[lang]
    },
    {
      field: "comment",
      headerName: globalLang.comment[lang],
      customContent: ({ rowData }) =>
        rowData?.comment?.length >= 18
          ? `${rowData?.comment?.slice(0, 8)}...`
          : rowData?.comment ? rowData?.comment : "-",
    },
    {
      field: "event",
      headerName: globalLang.status[lang],
      customContent: ({ rowData }) => rowData.event.length === 0 ? "-" : `${rowData.event}`,
    },
    {
      field: "history_date",
      headerName: globalLang.previewDate[lang],
      customContent: ({ rowData }) =>
        rowData.history_date ? format(rowData.history_date) : "",
    },
  ];

  //----effects----
  useAfterEffect(() => {
    if (!open) return;
    onOpen();
  }, [open]);

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogHeading>{globalLang.cusomerDetails[lang]}</DialogHeading>
  
      <DialogInfoWindow information={info} />
      <PermissionsGate permissions={["view_historicalaqarclient"]}>
        <DialogHeading>{globalLang.customerRecord[lang]}</DialogHeading>
        <DialogTable
          rows={historyStore?.results}
          columns={columns}
          isPending={isHistoryPending}
        />
      </PermissionsGate>
      <DialogButtonsGroup>
        <DialogButton variant="close" onClick={onClose}>
          {globalLang.cancel[lang]}
        </DialogButton>
      </DialogButtonsGroup>
    </Dialog>
  );
};

const TransferToEmployeeDialog = ({
  open,
  onOpen = () => { },
  onClose = () => { },
  onGoBack = () => { },
  isPending = false,
  submitPending = false,
  id,
  data = [],
  initSelected,
  onSubmit = () => { },
}) => {
  // Ghange lang
  const lang = useSelector((state) => state.lang.value.lang);
  const globalLang = useSelector((state) => state.lang.value.global);

  ///////////////////////////////
  const [selected, setSelected] = usePropState(initSelected, [initSelected]);
  const [searchValue, setSearchValue] = useState("");
  const [method, setMethod] = useState(1);

  const handleChangeSearchValue = (e) => {
    setSearchValue(e.target.value);
  };

  const handleSubmit = () => {
    onSubmit({
      agent: selected,
      client: id,
      option: Boolean(parseInt(method)),
    });
  };
  return (
    <Dialog
      open={open}
      onClose={onClose}
      onOpen={onOpen}
      paperProps={{
        maxWidth: 450,
      }}
    >
      <DialogHeading onGoBack={onGoBack}>
        {globalLang.TransferEmployee[lang]}
      </DialogHeading>
      <DialogPeopleWindow
        isPending={isPending}
        searchValue={searchValue}
        onSearch={handleChangeSearchValue}
        sx={{ height: 400 }}
      >
        {data
          ?.filter(
            (item) =>
              item?.title?.toLowerCase().includes(searchValue) ||
              item?.body?.toLowerCase().includes(searchValue)
          )
          ?.map((item, index) => (
            <DialogSelectItem
              key={`selectEmployeeItem ${index}`}
              selected={item.id === selected}
              picture={item.picture}
              title={item.title}
              body={item.body}
              onClick={() => setSelected(item.id)}
            />
          ))}
      </DialogPeopleWindow>
      <PermissionsGate permissions={["delete_historicalaqarclient"]}>
        <DialogContent>
          <FormGroup>
            <RadioGroup
              name="transfer-method"
              value={method}
              onChange={(e) => setMethod(e.target.value)}
            >
              <FormControlLabel
                control={
                  <Radio
                    sx={{
                      color: "white",
                      "& *": {
                        color: "white",
                      },
                    }}
                  />
                }
                label={globalLang.sameLevel[lang]}
                value={1}
              />
              <FormControlLabel
                control={
                  <Radio
                    sx={{
                      color: "white",
                      "& *": {
                        color: "white",
                      },
                    }}
                  />
                }
                label={globalLang.deleteRecords[lang]}
                value={0}
              />
            </RadioGroup>
          </FormGroup>
        </DialogContent>
      </PermissionsGate>
      <DialogButtonsGroup>
        <DialogButton onClick={handleSubmit} disabled={submitPending}>
          {globalLang.submit[lang]}
        </DialogButton>
        <DialogButton variant="close" onClick={onClose}>
          {globalLang.cancel[lang]}
        </DialogButton>
      </DialogButtonsGroup>
    </Dialog>
  );
};

TransferToEmployeeDialog.propTypes = {
  open: PropTypes.bool,
  isPending: PropTypes.bool,
  onClose: PropTypes.func,
  data: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      picture: PropTypes.string,
      title: PropTypes.string,
      body: PropTypes.string,
    })
  ),
};

const CommentDialog = ({
  open,
  onOpen = () => { },
  onClose = () => { },
  onGoBack = () => { },
  isPending = false,
  isStatusPending = false,
  onStatusOpen = () => { },
  data = [],
  id = null,
  status = [],
  onSubmit = () => { },
}) => {
  // Ghange lang
  const lang = useSelector((state) => state.lang.value.lang);
  const globalLang = useSelector((state) => state.lang.value.global);
  const clientCommentsStore = useSelector(
    (state) => state.clientComments.value
  );
    console.log(data)
  const userInfo = useSelector((state) => state.userInfo.value);

  const [commentDeleteRequest, commentDeleteResponse] = useRequest({
    path: CLIENTS_COMMENTS,
    method: "delete",
    successMessage: "تم الحذف بنجاح",
  });

  const dispatch = useDispatch();
  const handleDelete = (id, client_id) => {
    commentDeleteRequest({
      id: id,
      params: {
        id: client_id,
      },
      onSuccess: () => {
        dispatch({ type: "clientComments/deleteItem", payload: id });
      },
    });
  };

  const [handleDeleteComment, deleteCommentConfirmDialog] = useConfirmMessage({
    onConfirm: handleDelete,
    text: globalLang.makesureofdelete[lang],
  });
  const checpermissionExistence = (perm) =>
    userInfo.user_permissions?.some(({ codename }) => codename == perm);
  ///////////////////////////////
  const [search, setSearch] = useState("");
  const [
    { controls, required, invalid },
    { setControl, validate, resetControls },
  ] = useControls([
    {
      control: "comment",
      value: "",
      isRequired: true,
    },
    {
      control: "status",
      value: "",
      isRequired: true,
    },
  ]);

  const handleSubmit = () => {
    validate().then((output) => {
      if (!output.isOk) return;
      onSubmit({
        event: controls.status,
        comment: controls.comment,
        client: id,
      }).then((e) => {
        onClose()
        resetControls();

        // onClose()
      });
    });
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      onOpen={onOpen}
      paperProps={{
        maxWidth: 600,
      }}
    >
      <DialogHeading onGoBack={onGoBack}>
        {globalLang.comment[lang]}
      </DialogHeading>
      <DialogPeopleWindow
        searchValue={search}
        onSearch={(e) => setSearch(e.target.value)}
        isPending={isPending}
        sx={{ height: 400 }}
      >
        {clientCommentsStore?.results
          .filter(
            (item) =>
              item?.commenter?.fullname.includes(search) ||
              item?.comment.includes(search) ||
              item?.event.includes(search)
          )
          .map((item, index) => (
            <Box sx={{ maxWidth: "100%" }}>
              <DialogSelectItem
                key={`comment ${index}`}
                title={item?.commenter?.fullname}
                body={<><Typography component="p">
                    {item?.comment} 
                  </Typography>
                  <Typography component="p">
                    {[item?.event]}
                  </Typography></>}
                
                subtitle={item.created_at ? format(item.created_at) : ""}
                picture={item?.commenter?.image}
              />
              {checpermissionExistence("delete_aqarclientcomment") && (
                <IconButton>
                  <DeleteIcon
                    sx={{ width: 30, height: 30 }}
                    htmlColor="red"
                    onClick={(event) => {
                      event.stopPropagation();
                      handleDeleteComment(item.id, item.client_id);
                    }}
                  />
                </IconButton>
              )}
            </Box>
          ))}
        {deleteCommentConfirmDialog}
        {commentDeleteResponse.successAlert}
        {commentDeleteResponse.failAlert}
      </DialogPeopleWindow>
      <PermissionsGate permissions={["add_aqarclientcomment"]}>
        <DialogContent>
          <Stack spacing={2}>
            <TextareaField
              placeholder={globalLang.comment[lang]}
              sx={{
                "& .MuiInput-root": {
                  bgcolor: "white",
                },
              }}
              value={controls.comment}
              required={required.includes("comment")}
              error={Boolean(invalid?.comment)}
              helperText={invalid?.comment}
              onChange={(e) => setControl("comment", e.target.value)}
            />
            <SelectField
              placeholder={globalLang.status[lang]}
              isPending={isStatusPending}
              onOpen={onStatusOpen}
              sx={{
                "& .MuiInput-root": {
                  bgcolor: "white",
                },
              }}
              SelectProps={{
                MenuProps: {
                  PaperProps: {
                    sx: {
                      maxHeight: 100,
                      overflowY: "auto",
                    },
                  },
                },
              }}
              renderValue={(selected) =>
                status.find((item) => item.value === selected).name
              }
              value={controls.status}
              required={required.includes("status")}
              error={Boolean(invalid?.status)}
              helperText={invalid?.status}
              onChange={(e) => setControl("status", e.target.value)}
            >
              {status.map((item, index) => (
                <MenuItem key={`message status ${index}`} value={item.value}>
                  {item.name}
                </MenuItem>
              ))}
            </SelectField>
          </Stack>
        </DialogContent>
      </PermissionsGate>
      <DialogButtonsGroup>
        <DialogButton onClick={handleSubmit}>
          {globalLang.submit[lang]}
        </DialogButton>
        <DialogButton variant="close" onClick={onClose}>
          {globalLang.cancel[lang]}
        </DialogButton>
      </DialogButtonsGroup>
    </Dialog>
  );
};

const TransferToProjectDialog = ({
  open,
  onOpen = () => { },
  onClose = () => { },
  onGoBack = () => { },
  isPending = false,
  submitPending = false,
  id,
  data = [],
  onSubmit = () => { },
}) => {
  const [selected, setSelected] = useState([]);
  const [searchValue, setSearchValue] = useState("");

  const handleChangeSearchValue = (e) => {
    setSearchValue(e.target.value);
  };

  const handleSubmit = () => {
    onSubmit({
      bussiness: selected,
      client: id,
    });
  };

  const handleToggleSelect = (selectedItem) => {
    switch (selected.includes(selectedItem)) {
      case true:
        setSelected((old) => old.filter((item) => item !== selectedItem));
        break;
      case false:
        setSelected((old) => [...old, selectedItem]);
        break;
      default:
        setSelected((old) => old);
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      onOpen={onOpen}
      paperProps={{
        maxWidth: 450,
      }}
    >
      <DialogHeading onGoBack={onGoBack}>تغيير مشاريع المحدد</DialogHeading>
      <DialogPeopleWindow
        isPending={isPending}
        searchValue={searchValue}
        onSearch={handleChangeSearchValue}
        sx={{ height: 400 }}
      >
        
        {data
          ?.filter((item) => item.name.toLowerCase().includes(searchValue))
          ?.map((item, index) => (
            <DialogSelectItem
              key={`selectProjectItem ${index}`}
              selected={selected.includes(item.id)}
              picture={item.picture}
              body={item.name}
              onClick={() => handleToggleSelect(item.id)}
            />
          ))}
      </DialogPeopleWindow>
      <DialogButtonsGroup>
        <DialogButton onClick={handleSubmit} disabled={submitPending}>
          تنفيذ
        </DialogButton>
        <DialogButton variant="close" onClick={onClose}>
          إلغاء
        </DialogButton>
      </DialogButtonsGroup>
    </Dialog>
  );
};

TransferToProjectDialog.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      picture: PropTypes.string,
    })
  ),
};

const EditDialog = ({ open, onClose, data }) => {
  // Change lang
  const lang = useSelector((state) => state.lang.value.lang);
  const globalLang = useSelector((state) => state.lang.value.global);

  ///////////////////////////////

  const contactMeans = [
    {
      title: globalLang.phone[lang],
      value: "phone",
    },
    {
      title: globalLang.email[lang],
      value: "email",
    },
    {
      title: globalLang.whatsApp[lang],
      value: "whats app",
    },
  ];
  const [{ controls, invalid,required }, { setControl, validate }] = useControls(
    [
      {
        control: "name",
        value: `${data?.name}`,
        // validations: [
        //   {
        //     test: /^[a-zA-Z\s]+$/,
        //     message: globalLang.textname[lang],
        //   },
        // ],
      },
      {
        control: "email",
        value: data?.email,
        validations: [
          {
            test: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
            message: "البريد غير صالح",
          },
        ],
      },
      {
        control: "code",
        value: data?.country_code?data?.country_code:"+20",
      },
      {
        control: "additional_country_code",
        value: data?.additional_country_code?data?.additional_country_code:"+20",
      },
      {
        control: "phone",
        value: data?.phone,
       
      },
      {
        control: "additional_phone",
        value: data?.additional_phone,
      },

      {
        control: "project",
        value: data?.bussiness?.map((project) => project.id) ?? [],

        convert: (project) => project.join("-"),
      },
      {
        control: "contact",
        value: data?.fav_contacts,
      },
      {
        control: "channel",
        value: data?.channel?.id,
      },
      {
        control: "min_price",
        value: data?.min_price,
        isRequired: false,
        
      },
      {
        control: "max_price",
        value: data?.max_price,
        isRequired: false,
        validations: [
          {
            customValidation: (controls) => controls.max_price>controls.min_price,
            message:globalLang.greatpricethanmin[lang],
          },
        ],
      },
    ],
    [data]
  );

  const [projectsState, setProjectsState] = useState([]);
  const [projectsGetRequest, projectsGetResponse] = useRequest({
    path: PROJECTS,
    method: "get",
  });
  const getProjects = () => {
    if (projectsState.length) return;
    projectsGetRequest({
      params: {
        size: 1000,
      },
      onSuccess: (res) => {
        setProjectsState(res.data.results);
      },
    });
  };

  const [channelsState, setChannelsState] = useState([]);
  const [channelsGetRequest, channelsGetResponse] = useRequest({
    path: CHANNELS,
    method: "get",
  });
  const getChannels = () => {
    if (channelsState.length) return;
    channelsGetRequest({
      params: {
        size: 1000,
      },
      onSuccess: (res) => {
        setChannelsState(res.data.results);
      },
    });
  };

  const [clientPatchRequest, clientPatchResponse] = useRequest({
    path: CLIENTS,
    method: "patch",
    successMessage: "تم تعديل العميل بنجاح",
  });

  const dispatch = useDispatch();

  const handleSubmit = () => {

    const isThereChange = compare(
      [
        [controls.name, data?.name, "name"],
        [controls.email, data?.email, "email"],
        [controls.project, data?.bussiness.map((project) => project.id), "bussiness"],
        [controls.channel, data?.channel?.id, "channel"],
        [controls.contact, data?.fav_contacts, "fav_contacts"],
        // [controls.budget, data?.max_budget, "max_budget"],
        [Number(controls.min_price), data?.min_price, "min_price"],
        [Number(controls.max_price), data?.max_price, "max_price"],
        
        [controls.additional_phone, data?.additional_phone, "additional_phone"],
        [controls.phone, data?.phone, "phone"]
      ],
      false
    );
    if (isThereChange.nochange) {
      validate().then(({ isOk }) => {
        if (!isOk) return;
        const requestBody = filter({
          obj: {
            name: isThereChange.array["name"],
            phone: isThereChange.array["code"] ? isThereChange.array["code"] + isThereChange.array["phone"] ? isThereChange.array["phone"] : controls.phone : isThereChange.array["phone"] ? controls.code + isThereChange.array["phone"] : undefined,
            additional_phone: isThereChange.array["additional_phone"] && isThereChange.array["additional_country_code"] ? isThereChange.array["additional_country_code"] + isThereChange.array["additional_phone"] : !isThereChange.array["additional_phone"] && isThereChange.array["additional_country_code"] ?isThereChange.array["additional_country_code"] + controls.additional_phone:isThereChange.array["additional_phone"] && !isThereChange.array["additional_country_code"]?controls.additional_country_code+isThereChange.array["additional_phone"]:undefined,
            email: isThereChange.array["email"],
            ...(Boolean(controls.project.length) && {
              bussiness: isThereChange.array["bussiness"],
            }),
            channel: isThereChange.array["channel"],
            agent: isThereChange.array["employee"],
            fav_contacts: isThereChange.array["fav_contacts"],
            min_price: isThereChange.array["min_price"],
            max_price: isThereChange.array["max_price"],
            country_code: isThereChange.array["code"]
          },
        });
        // console.log(isThereChange.array["additional_country_code"]?isThereChange.array["additional_country_code"]+isThereChange.array["additional_phone"]?isThereChange.array["additional_phone"]):controls.additional_phone
        // console.log(isThereChange.array["additional_country_code"]?isThereChange.array["additional_country_code"]:controls.additional_country_code+isThereChange.array["additional_phone"]?isThereChange.array["additional_phone"]:controls.additional_phone)

        clientPatchRequest({
          id: data.id,
          body: requestBody,
          onSuccess: (res) => {
   
            dispatch({
              type: "clients/patchItem",
              payload: { id: res.data.id, item: res.data }
            })
            onClose();
          }
        })
      })
    } else {
      onClose();
    }


  };

  return (<>
    <Dialog open={open} onClose={onClose}>
      <DialogHeading onGoBack={onClose}>
        {globalLang.editCusomerData[lang]}
      </DialogHeading>
      <DialogForm>
        <DialogInputField
          placeholder={globalLang.name[lang]}
          label={globalLang.name[lang]}
          value={controls.name}
          onChange={(e) =>{ let text=/^(?:[A-Za-z\u0600-\u06ff\s]*)$/
          let match=text.test(e.target.value)
          if(match){
            setControl("name", e.target.value)
          }}}
          error={Boolean(invalid.name)}
          helperText={invalid.name}
        />
        <DialogInputField
          placeholder={globalLang.email[lang]}
          label={globalLang.email[lang]}
          value={controls.email}
          onChange={(e) => setControl("email", e.target.value)}
          error={Boolean(invalid.email)}
          helperText={invalid.email}
        />
        <DialogPhoneField
          placeholder={globalLang.phone[lang]}
          label={globalLang.phone[lang]}
          value={controls.phone}
          onChange={(e) => setControl("phone", e.target.value)}
          selectProps={{
            value: controls.code,
            onChange: (e) => setControl("code", e.target.value),
          }}
          error={Boolean(invalid.phone)}
          helperText={invalid.phone}
        />
        <DialogPhoneField
          label={globalLang.additional_phone[lang]}
          placeholder={globalLang.additional_phone[lang]}
          selectProps={{
            value: controls.additional_country_code,
            onChange: (e) => setControl("additional_country_code", e.target.value)
          }}
          value={controls.additional_phone}
          onChange={(e) => { console.log(e.target.value); return setControl("additional_phone", e.target.value) }}
          error={Boolean(invalid.additional_phone)}
          helperText={invalid.additional_phone}
        />
        <DialogMultiSelectField
          placeholder={globalLang.project[lang]}
          label={globalLang.project[lang]}
          onOpen={getProjects}
          isPending={projectsGetResponse.isPending}
          value={controls.project}
          onChange={(e) => {
            setControl("project", [...e.target.value]);
          }}
          renderValue={(selected) => {
            return selected
              ?.map(
                (id) => projectsState.find((project) => project.id === id)?.name
              )
              .filter((item) => Boolean(item)).length
              ? selected
                ?.map(
                  (id) =>
                    projectsState.find((project) => project.id === id)?.name
                )
                ?.join(" ، ")
                .trim()
              : data?.bussiness?.map((project) => project?.name).join(" ، ");
          }}
          error={Boolean(invalid.project)}
          helperText={invalid.project}
        >
          {projectsState.map((project, index) => (
            <MultiSelectItem
              value={project.id}
              key={`edit client project ${index}`}
            >
              {project.name}
            </MultiSelectItem>
          ))}
        </DialogMultiSelectField>
        <DialogSelectField
          placeholder={globalLang.contactWay[lang]}
          label={globalLang.contactWay[lang]}
          value={controls.contact}
          onChange={(e) => setControl("contact", e.target.value)}
          renderValue={(selected) => {
            return contactMeans.find((mean) => mean.value === selected).title;
          }}
          error={Boolean(invalid.contact)}
          helperText={invalid.contact}
        >
          {contactMeans.map((mean, index) => (
            <MenuItem value={mean.value} key={`${mean.value} ${index}`}>
              {mean.title}
            </MenuItem>
          ))}
        </DialogSelectField>
        <DialogSelectField
          placeholder={globalLang.adChannel[lang]}
          label={globalLang.adChannel[lang]}
          onOpen={getChannels}
          isPending={channelsGetResponse.isPending}
          value={controls.channel}
          onChange={(e) => setControl("channel", e.target.value)}
          renderValue={(selected) => {
            return (
              channelsState.find((channel) => channel.id === selected)?.name ??
              data?.channel?.name
            );
          }}
          error={Boolean(invalid.channel)}
          helperText={invalid.channel}
        >
          {channelsState.map((channel, index) => (
            <MenuItem value={channel.id} key={`edit client channel ${index}`}>
              {channel.name}
            </MenuItem>
          ))}
        </DialogSelectField>
        
          <DialogInputField
          label={globalLang.min_price[lang]}
          placeholder={globalLang.min_price[lang]}
          // onOpen={getGovernorates}
          // isPending={statesGetResponse.isPending}
          value={controls.min_price}
          onChange={(e) => {
            const inputValue = parseInt(e.target.value, 10); // Parse the input value as an integer
          const newValue = isNaN(inputValue) ? 0 : Math.max(inputValue, 0);
            setControl("min_price", newValue);
          }}
          type="number"
          required={required.includes("min_price")}
          error={Boolean(invalid.min_price)}
          helperText={invalid.min_price}
        />
        <DialogInputField
          label={globalLang.max_price[lang]}
          placeholder={globalLang.max_price[lang]}
          value={controls.max_price}
          onChange={(e) => {  const inputValue = parseInt(e.target.value, 10); // Parse the input value as an integer
          const newValue = isNaN(inputValue) ? 0 : Math.max(inputValue, 0); ;setControl("max_price", newValue)}}
          type="number"
          required={required.includes("max_price")}
          error={Boolean(invalid.max_price)}
          helperText={invalid.max_price}
        />
      </DialogForm>
      <DialogButtonsGroup>
        <DialogButton
          onClick={handleSubmit}
          disabled={clientPatchResponse.isPending}
        >
          {globalLang.save[lang]}
        </DialogButton>
        <DialogButton variant="close" onClick={onClose}>
          {globalLang.cancel[lang]}
        </DialogButton>
      </DialogButtonsGroup>

    </Dialog>
    {clientPatchResponse.failAlert}
    {clientPatchResponse.successAlert}
  </>
  );
};
